"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncDebounce = asyncDebounce;
exports.firstLetterUppercase = exports.escapeRegExp = exports.currencySymbols = exports.capitalize = void 0;
exports.isEmpty = isEmpty;
exports.isNumber = isNumber;
exports.link = link;
exports.nameToInitials = nameToInitials;
exports.parseNumber = parseNumber;
exports.snakeToCamel = exports.sleep = void 0;
exports.toMap = toMap;
exports.uuid = void 0;

var _escapeRegExp2 = _interopRequireDefault(require("lodash/escapeRegExp"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isFinite = _interopRequireDefault(require("lodash/isFinite"));

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _currencySymbols = _interopRequireDefault(require("../constants/currencySymbols"));

/**
 * Generate a GUID
 * @returns {string}
 */
var uuid = function uuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return "".concat(s4() + s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4()).concat(s4()).concat(s4());
};
/**
 * Set a name to a pair on initials
 * @param input {String} The name to manipulate
 * @returns {String}
 */


exports.uuid = uuid;

function nameToInitials(input) {
  var name = (0, _isNil["default"])(input) ? '' : input.toUpperCase();
  return name && name.replace(/[\W_][ ]+/g, '').split(' ').slice(0, 2).map(function (word) {
    return word.charAt(0);
  }).join('');
}
/**
 * Check if string value is a valid number
 * @param str {String | Number}  The string to test
 * @returns {Boolean}
 */


function isNumber() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if ((0, _isNumber2["default"])(str)) {
    return true;
  }

  if ((0, _isEmpty2["default"])(str)) {
    return false;
  }

  if (str.length === 1) {
    return RegExp(/^[0-9.]+$/).test(str);
  }

  return (0, _isFinite["default"])(+str);
}
/**
 * Convert a string into Number (float)
 * @param str {String|Number}  The value to parse
 * @param catchValue {String | Number} value to return if cast to number fails, defaults to NaN
 * @returns {number} Number if valid number string otherwise NaN
 */


function parseNumber(str) {
  var catchValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;

  if (isNumber(str)) {
    return +str;
  }

  return Number(str) || catchValue;
}
/**
 * Convert and array to a Map
 * @param array {Array} an array to map
 * @param key {*} the value to key by
 * @returns {Map} a new map
 */


function toMap() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return new Map(array.map(function (item) {
    return [item[key] || item, item];
  }));
}
/**
 * Create a delay mechanism
 * @param ms  {Number}  Milliseconds to delay
 * @return {Promise<any>}
 */


var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
/**
 * Escape string for RegExp
 * uses lodash escapeRegExp util
 * @param str  {String}  string to escape
 * @return {String}
 */


exports.sleep = sleep;

var escapeRegExp = function escapeRegExp(str) {
  return (0, _escapeRegExp2["default"])(str);
};
/**
 * First letter to uppercase
 * @param text {String}  string to manipulate
 * @return {String}
 */


exports.escapeRegExp = escapeRegExp;

var firstLetterUppercase = function firstLetterUppercase(text) {
  return text.slice(0, 1).toUpperCase() + text.slice(1, text.length);
};
/**
 * Capitalize first letter
 * @param text {String}  string to manipulate
 * @return {String}
 */


exports.firstLetterUppercase = firstLetterUppercase;

var capitalize = function capitalize() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return text.slice(0, 1).toUpperCase() + text.slice(1, text.length);
};
/**
 * Currency symbols mapper
 */


exports.capitalize = capitalize;
var currencySymbols = _currencySymbols["default"];
/**
 * Perform async debounce
 * @param f {Function}  Function to debounce
 * @param interval  {Number}  Milliseconds to interval
 * @return {function(...[*]=): Promise<any>}
 */

exports.currencySymbols = currencySymbols;

function asyncDebounce(f, interval) {
  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    return new Promise(function (resolve) {
      timer = setTimeout(function () {
        return resolve(f.apply(void 0, args));
      }, interval);
    });
  };
}
/**
 * Bullet proof is empty to also check numbers
 * @param value
 * @return {boolean}
 */


function isEmpty(value) {
  return !(0, _isNumber2["default"])(value) && (0, _isEmpty2["default"])(value);
}
/**
 * Link to url
 * @param location  {String}  The full path for the link
 * @param isNewTab  {Boolean} Indicator whether or not to show in new tab ( auto - true)
 */


function link(location) {
  var isNewTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (isNewTab) {
    window.open(location, '_blank');
  } else {
    window.location.replace(location);
  }
}

var snakeToCamel = function snakeToCamel(str) {
  return str.replace(/([-][a-z])/g, function (group) {
    return group.toUpperCase().replace('-', '');
  });
};

exports.snakeToCamel = snakeToCamel;